import { useRef } from "react";
import { useGetConfig } from "@onefront/forrestjs-react-root";
import { useQueryString } from "../../utils/use-query-string";
import { useIsEmbed } from "../../utils/use-is-embed";

export const useLayoutEmbed = () => {
  const { isEmbed, urlKey } = useIsEmbed();

  const tokenParam = useGetConfig("one.auth.token.param", "token");
  const stateParam = useGetConfig("one.axios.sessions.param.key", "ctx");
  const KNOWN_PARAMS = [
    urlKey,
    `${urlKey}ID`,
    `${urlKey}Scope`,
    tokenParam,
    stateParam
  ];

  const qs = useQueryString();
  const queryString = qs.getAllItems();

  const embedID = useRef(queryString[`${urlKey}ID`]);
  const embedScope = useRef(queryString[`${urlKey}Scope`]);

  const embedParams = useRef({});
  Object.keys(queryString).forEach((key) => {
    const value = queryString[key];
    if (!KNOWN_PARAMS.includes(key) && Boolean(value)) {
      embedParams.current[key] = value;
    }
  });

  return {
    isEmbed,
    embedID: embedID.current,
    embedScope: embedScope.current,
    embedParams: embedParams.current
  };
};
